import React, { useContext, useState } from "react";
import { Button, Form, H3 } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { AuthContext } from "../../Context/AuthContext";
import { getFormComponent, processFormData } from "../../helpers/formHandlers";
import LoginIcon from "../../Icons/LoginIcon";
import { loginClient } from "../../api/auth";
import VerifyCodeForm from "../VerifyCodeForm/VerifyCodeForm";
import { emailProps, passwordProps } from "../../helpers/formProps";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";

const formStyle = css`
  padding: 0 4vh 3vh;
  gap: 3vh;
  align-items: center;
`;

const h3Style = css`
  font-size: 2.2vh;
  font-weight: 200;
  align-self: flex-start;
`;

const resetPassworrdBttn = css`
  align-self: flex-start;
  color: ${({ theme }) => theme.main};
  font-size: 1.25vh;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 0.25vh;
  margin-top: -1.5vh;
  font-family: sans-serif;
  /* border:2px solid red; */
`;

const loginFormProps = [emailProps(), passwordProps()]

const LoginForm = ({ setFormType, showToast, setPopUp }) => {
  const { login } = useContext(AuthContext);
  const [formData, setForm] = useState(loginFormProps);
  const [loginStep, setLoginStep] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const processedData = processFormData(formData);
    if (processedData.errors) {
      return showToast({
        title: `${processedData.formErrors[0].label} error`,
        text: `${processedData.formErrors[0].errors}`,
        type: "Error",
        hidden: false,
      });
    }

    try {
      await loginClient(processedData);
      // setLoading(false);
      showToast({
        type: "Success",
        title: "Success",
        text: "You are now logged in.",
        hidden: false,
      });
      login();
      setPopUp({ isOpen: false, component: null });
    } catch (error) {
      console.error("Contact request failed:", error);
      // setLoading(false);
      if (error.status === 403) {
        return setLoginStep(1);
      }
      return showToast({
        title: "Unexpected error",
        text: `${error.message}`,
        type: "Error",
        hidden: false,
      });
    }
  };

  if (loginStep === 0) {
    return (
      <Form $baseStyle={formStyle} onSubmit={(e) => handleSubmit(e)}>
        <H3 $baseStyle={h3Style}>Enter your login credentials.</H3>
        {formData.map((props, index) =>
          getFormComponent({ props, setForm, index })
        )}
        <Button
          $baseStyle={resetPassworrdBttn}
          type="button"
          onClick={() => setFormType(1)}
        >
          Forgot password?
        </Button>
        <FormSubmissionBttn text="Login" icon={<LoginIcon />}/>
      </Form>
    );
  }
  if (loginStep === 1) {
    return (
      <VerifyCodeForm
        showToast={showToast}
        credentials={[formData[0].value, formData[1].value]}
        {...(typeof setPopUp === "function" && {
          actionForm: () => setPopUp({ isOpen: false, component: null }),
        })}
      />
    );
  }
};

export default LoginForm;
